import { __exports as e } from "../../../../../../../../../_virtual/default.js";
Object.defineProperty(e, "__esModule", {
  value: !0
});
e.DEFAULT_CONFIG = void 0;
var a = ["ic-attribute", "ic-block", "ic-marker", "ic-mention"], r = {
  ADD_TAGS: ["iframe"],
  ADD_ATTR: ["allowfullscreen", "frameborder", "target"],
  CUSTOM_ELEMENT_HANDLING: {
    tagNameCheck: function(t) {
      return a.includes(t);
    },
    attributeNameCheck: /^(data-|contenteditable)/,
    allowCustomizedBuiltInElements: !1
  }
};
e.DEFAULT_CONFIG = r;
export {
  e as default
};
